import React, { FC } from 'react'
import { UserDetailsForm } from './components/UserDetailsForm'
import { LayerPermissionsTable } from './components/LayerPermissionsTable/LayerPermissionsTable'
import { AreaPermissions } from './components/AreaPermissions'
import { BlockUserAction } from './components/BlockUserAction'
//import { RemoveUserAction } from './components/RemoveUserAction'
import { Link } from 'react-router-dom'
import { Flex } from 'components/Flex'
import { Stack } from 'components/Stack'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { useTranslation } from 'react-i18next'
import { ProjectPermissionsTable } from './components/ProjectsPermissionsTable'
import { useParams } from 'react-router-dom'
import { useFetchUser, useFetchUserPermissions } from 'services/user'
import { useUserContext } from 'context/user-context'
import styles from './EditUser.module.scss'

export const EditUser: FC = () => {
  const [currentUser] = useUserContext()
  const { t } = useTranslation()
  const { userId } = useParams()
  const { user } = useFetchUser(userId)
  const { permissions } = useFetchUserPermissions(userId)

  if (!user) return null

  return (

    <div className={styles.editUser}>
      <Stack space="small">
        <Flex justify="between" align="center">
          <Heading>{t('user.edit.title')}</Heading>
          <Link to="/organization/users">
            <Text>{t('user.edit.return')}</Text>
          </Link>
        </Flex>
        <Stack space="xlarge">
          <UserDetailsForm user={user} currentUser={currentUser!} />
          {permissions && [
            <ProjectPermissionsTable
              key="project_permissions"
              userId={user.id}
              permissions={permissions.projects}
            />,

            <AreaPermissions
              key="area_permissions"
              userId={user.id}
              permissions={permissions.area}
            />,
            <LayerPermissionsTable
              key="layer_permissions"
              userId={user.id}
              permissions={permissions.layers}
            />,
          ]}
          {user.confirmed && <BlockUserAction user={user} />}
          {/*<RemoveUserAction user={user} />*/}
        </Stack>
      </Stack>
    </div>
  )
}

EditUser.displayName = 'EditUser'
